/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Topsellers1Inputs */

const id_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlaris`)
};

const ms_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlaris`)
};

const da_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedst sælgende`)
};

const de_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meistverkauft`)
};

const en_us2_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Sellers`)
};

const es_es2_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más vendidos`)
};

const es_mx2_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más vendidos`)
};

const fil_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakamabenta`)
};

const fr_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleures ventes`)
};

const it_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più venduti`)
};

const hu_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legkelendőbbek`)
};

const nl_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best verkopend`)
};

const no_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest solgte`)
};

const pl_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepiej sprzedawane`)
};

const pt_br2_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais vendidos`)
};

const pt_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais vendidos`)
};

const ro_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best-seller`)
};

const fi_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Myydyimmät`)
};

const sv_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bästsäljare`)
};

const vi_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bán chạy nhất`)
};

const tr_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Çok Satanlar`)
};

const cs_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejprodávanější`)
};

const bg_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-продавани`)
};

const ru_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лидеры продаж`)
};

const uk_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найпродаваніші`)
};

const ar_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأكثر مبيعًا`)
};

const hi_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टॉप सेलर्स`)
};

const th_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขายดีที่สุด`)
};

const ja_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トップセラー`)
};

const zh_cn2_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`畅销榜`)
};

const zh_hant1_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暢銷榜`)
};

const ko_nav_topsellers1 = /** @type {(inputs: Nav_Topsellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최고 판매`)
};

/**
* | output |
* | --- |
* | "Top Sellers" |
*
* @param {Nav_Topsellers1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_topsellers1 = /** @type {((inputs?: Nav_Topsellers1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Topsellers1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_topsellers1(inputs)
	if (locale === "ms") return ms_nav_topsellers1(inputs)
	if (locale === "da") return da_nav_topsellers1(inputs)
	if (locale === "de") return de_nav_topsellers1(inputs)
	if (locale === "en-US") return en_us2_nav_topsellers1(inputs)
	if (locale === "es-ES") return es_es2_nav_topsellers1(inputs)
	if (locale === "es-MX") return es_mx2_nav_topsellers1(inputs)
	if (locale === "fil") return fil_nav_topsellers1(inputs)
	if (locale === "fr") return fr_nav_topsellers1(inputs)
	if (locale === "it") return it_nav_topsellers1(inputs)
	if (locale === "hu") return hu_nav_topsellers1(inputs)
	if (locale === "nl") return nl_nav_topsellers1(inputs)
	if (locale === "no") return no_nav_topsellers1(inputs)
	if (locale === "pl") return pl_nav_topsellers1(inputs)
	if (locale === "pt-BR") return pt_br2_nav_topsellers1(inputs)
	if (locale === "pt") return pt_nav_topsellers1(inputs)
	if (locale === "ro") return ro_nav_topsellers1(inputs)
	if (locale === "fi") return fi_nav_topsellers1(inputs)
	if (locale === "sv") return sv_nav_topsellers1(inputs)
	if (locale === "vi") return vi_nav_topsellers1(inputs)
	if (locale === "tr") return tr_nav_topsellers1(inputs)
	if (locale === "cs") return cs_nav_topsellers1(inputs)
	if (locale === "bg") return bg_nav_topsellers1(inputs)
	if (locale === "ru") return ru_nav_topsellers1(inputs)
	if (locale === "uk") return uk_nav_topsellers1(inputs)
	if (locale === "ar") return ar_nav_topsellers1(inputs)
	if (locale === "hi") return hi_nav_topsellers1(inputs)
	if (locale === "th") return th_nav_topsellers1(inputs)
	if (locale === "ja") return ja_nav_topsellers1(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_topsellers1(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_topsellers1(inputs)
	return ko_nav_topsellers1(inputs)
});
export { nav_topsellers1 as "nav.topSellers" }